export default {
  // API_ROOT: 'https://clients.nicomit.com/mh-1093/atlantic-pilotage/api/', // DEV
  API_ROOT: 'https://pilots.atlanticpilotage.com/api/', // PROD
}
